import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useWorkStateFields } from '../store/hooks';
import axios from "axios";
import { Link } from "react-router-dom";
import { getWhatsappShareUrl, getAuthToken, getAPIUrl, isMobile, defaultQuality, isAdmin,
         get_logo, catchError, get_platform_action_color, formatTime, isLandScape } from "../script/util.js";
import { openExternalApp } from '@egreact/shared';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import copy from "clipboard-copy";
import Popup from "../components/Popup/Popup.js"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faCaretRight, faGear, faCaretLeft, faDownload, faShareNodes, faCopy, faRotateLeft, faBackward, faForward, faPlay, faPause, faForwardStep } from '@fortawesome/free-solid-svg-icons';
import CommentBox from './comments/CommentBox.jsx'
import commentIcon from '../images/commentIcon.png'
import { usePostHog } from 'posthog-js/react';
import RECORDING_FLAGS from '../script/posthogFlags';

const VideoPlayer = (getData) => {
    const [data, setData] = useState(getData.data)
    const [videoUrl, setVideoUrl] = useState()
    const [openMenu, setOpenMenu] = useState(false)
    const [openQuality, setOpenQuality] = useState(false)
    const [openRate, setOpenRate] = useState(false)
    const playBackRef = useRef(null)
    const [userActive, setUserActive] = useState(true)
    const commentRef = useRef(null)
    const downloadRef = useRef(null)
    const currRef = useRef(null)
    const retryRef = useRef(null)
    const forwardRef = useRef(null)
    const backwardRef = useRef(null)
    const [isPaused, setIsPaused] = useState(true);
    const videoRef = useRef(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [overlay, setOverlay] = useState(false)
    const [shareUrl, setShareUrl] = useState();
    const [linkCopied, setLinkCopied] = useState(false);
    const playerRef = useRef(null);
    const defQuality = defaultQuality()
    const [runQuality, setRunQuality] = useState(defQuality)
    const [orientation, setOrientation] = useState(
        window.matchMedia("(orientation: portrait)").matches ? "portrait" : "landscape"
    );
    const [playbackPosition, setPlaybackPosition] = useState(0);
    const [playbackRate, setPlaybackRate] = useState('Normal')
    const [completedTime, setCompletedTime] = useState(0);
    const [videoDuration, setVideoDuration] = useState(0);
    const [qualityShortName, setQualityShortName] = useState()
    const videoOrientation = useRef();
    const lastOrientationRef = useRef(orientation);
    const [qualityVideo, setQualityVideo] = useState(false)
    const [videoDetails, setVideoDetails] = useState()
    const [downloadQuality, setDownloadQuality] = useState(defQuality);
    const [downloadQualityUrl, setDownloadQualityUrl] = useState();
    const [commentBox, setCommentBox] = useState(false)
    const [commentText, setCommentText] = useState("")
    const [commentStartTime, setCommentStartTime] = useState(null)
    const [commentEndTime, setCommentEndTime] = useState(null)
    const [showCommentTooltip, setShowCommentTooltip] = useState(false)
    const commentTooltipTimeoutRef = useRef(null)
    const { currentDimensions, setCurrentDimensions, nextVideo } = useWorkStateFields(['currentDimensions', 'nextVideo']);
    const posthog = usePostHog();
    const shared_key = useMemo(() => new URLSearchParams(window.location.search).get("key"), [])

    useEffect(()=>{
        setData(getData.data)
    },[])

    useEffect(() => {
      if (data?.can_request_changes && !shared_key) {
        setShowCommentTooltip(true)
        if (commentTooltipTimeoutRef.current) clearTimeout(commentTooltipTimeoutRef.current)
        commentTooltipTimeoutRef.current = setTimeout(() => {
          setShowCommentTooltip(false)
        }, 10000)
      }
      return () => {
        if (commentTooltipTimeoutRef.current) clearTimeout(commentTooltipTimeoutRef.current)
      }
    }, [data?.can_request_changes, shared_key])

    useEffect(()=>{
      data.url_list.map((e)=>{
        if(e.quality == runQuality){
          setQualityShortName(e.short_name)
        }
      })
    },[runQuality])

    useEffect(() => {
        if(videoRef.current && data){
          playerRef.current = videojs(videoRef.current, {
            autoplay: false,
            controls: true,
            sources: [{ src: getData.videoUrl, type: 'video/mp4' }],
            techOrder: ['html5'], 
              html5: {
                playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 2], 
              },
          });
    
          playerRef.current?.ready(() => {
            try {
              playerRef.current?.controlBar.addChild('PlaybackRateMenuButton', {}, 6);
              const bar =  playerRef.current?.controlBar.el();
              const fullscreenButton = bar.querySelector('.vjs-picture-in-picture-control');
              const playDefault = bar.querySelector('.vjs-play-control')
              const volumeDefault = bar.querySelector('.vjs-volume-panel')
              if(isMobile())playDefault.style.display = 'none'
              bar?.insertBefore(playBackRef.current,fullscreenButton);
              commentRef.current && bar?.insertBefore(commentRef.current,fullscreenButton);
              retryRef.current && bar?.insertBefore(retryRef.current,playDefault);
              backwardRef.current && bar?.insertBefore(backwardRef.current,playDefault);
              forwardRef.current && bar?.insertBefore(forwardRef.current,volumeDefault);
              downloadRef.current && bar?.insertBefore(downloadRef.current,fullscreenButton);
            } catch (e) {
              console.log('VideoPlayer control bar setup:', e.message);
            }
          });
          playerRef.current.on('play', ()=>{
            setIsPaused(false)
          });
          playerRef.current.on('pause', ()=>{
            setIsPaused(true)
          });

          playerRef.current.on('loadedmetadata', function() {
            setVideoDuration(playerRef.current?.duration() || 0);
            const x = document.getElementsByClassName('vjs-text-track-display')
            var width = x[0].offsetWidth;
            var height = x[0].offsetHeight;
            if(width>height){
              videoOrientation.current = 'landscape'
            }else {
              videoOrientation.current = 'portrait'
            }
          });

          playerRef.current.on('timeupdate', () => {
            const currentTime = playerRef.current?.currentTime();
            setCompletedTime(currentTime);
            const bar =  playerRef.current?.controlBar.el();
            const minutes = Math.floor(currentTime / 60);
            const remainingSeconds = Math.floor(currentTime % 60);
            const secondsString = remainingSeconds.toString().padStart(2, '0');
            const remainingTime = document.getElementsByClassName('vjs-remaining-time')
            if(remainingTime[0])remainingTime[0].style.display = 'none'
            const qltyDiv = document.getElementsByClassName('qualityDiv')[0]
            const currTime = document.getElementsByClassName('currentTime')
            const totalDuration = document.getElementsByClassName('vjs-time-control')
            if(isMobile() && !isLandScape()){
              if(commentBox){
                bar.style.bottom = currentDimensions < 600 ? 0.08*window.innerHeight + 'px' : 0.15*window.innerHeight + 'px'
              }else{
                bar.style.bottom = 0.2*window.innerHeight + 'px'
              }
              bar.style.height = currentDimensions < 600 && '10%'
              currTime[0].style.display = 'flex'
              currTime[0].style.position = currentDimensions < 600 && 'absolute'
              currTime[0].style.top = currentDimensions < 600 && '0'
              currTime[0].style.right = currentDimensions < 600 && '5%'
              for (let i = 0; i < totalDuration.length - 1; i++) {
                totalDuration[i].style.display = 'none';
              }
            }else{
              bar.style.bottom = commentBox ? 0.13*window.innerHeight + 'px' : 0.1*window.innerHeight + 'px'
              if(currTime[0])currTime[0].style.display = 'none'
              for (let i = 0; i < totalDuration.length - 1; i++) {
                totalDuration[i].style.display = 'block';
              }
            }
            currRef?.current && bar?.insertBefore(currRef.current, qltyDiv)
            if(currTime[0])currTime[0].textContent = `${minutes}:${secondsString}`
          });
    
          playerRef.current?.on('userinactive', ()=>{
            setTimeout(()=>{
              setOpenQuality(false)
              setOpenRate(false)
              setOpenMenu(false)
              if(!playerRef.current?.paused()){
                setUserActive(false)
                setOverlay(false)
              }
            },2000)
          })
          document.addEventListener('mousemove', debounce(handleMouseMove, 100));
          document.addEventListener('click', handleMouseClick);
          document.addEventListener('touchstart', debounce(handleMouseMove, 100));
          return () => {
            document.removeEventListener('mousemove', debounce(handleMouseMove, 100));
            document.removeEventListener('click', debounce(handleMouseClick, 100));
            document.addEventListener('touchstart', handleMouseMove);
            if (!playerRef.current) {
              playerRef.current?.pause()
              playerRef.current?.dispose();
            }
          };
        } 
      }, [data, playerRef.current, commentBox]);

    useEffect(()=>{
      const bar = document.getElementsByClassName('vjs-control-bar')[0]
      if(!isLandScape()){
        if(commentBox){
          bar.style.bottom = currentDimensions < 600 ? 0.08*window.innerHeight + 'px' : 0.15*window.innerHeight + 'px'
        }else{
          bar.style.bottom = 0.2*window.innerHeight + 'px'
        }
      }
    },[commentBox])

    const showMenu = () => {
        setOpenMenu((prev)=>!prev)
        setOpenQuality(false)
        setOpenRate(false)
    }

    const manualPlay = () => {
        if(playerRef.current?.paused()){
        setIsPaused(false)
        playerRef.current?.play()?.catch(e => console.log('play:', e.message))
        setTimeout(()=>{
            setOpenQuality(false)
            setOpenRate(false)
            setOpenMenu(false)
            if(!playerRef.current?.paused()){
            setUserActive(false)
            setOverlay(false)
            }
        },2000)
        }else{
        setIsPaused(true)
        playerRef.current?.pause()
        }
    }


    useEffect(()=>{
        if(data){
          for(let i = 0; i<data.url_list?.length; i++){
            if(data.url_list[i].quality == runQuality){
              setVideoUrl(data.url_list[i].url)
              playerRef?.current?.src(data.url_list[i].url)
              playerRef?.current?.load()
              playerRef?.current?.currentTime(playbackPosition);
              playerRef?.current?.play()?.catch(e => console.log('play:', e.message))
            }
            setOpenQuality(false)
            playbackPosition !==0 && setOpenMenu(true)
          }
        }
      },[runQuality])


    const headers = { Authorization: getAuthToken() };
    const inputData = { data_id_list: [`${getData.id}`] };

    const ShareCall = () => {
        playerRef.current?.pause()
        setIsPopupOpen(true)
        // setIsOpen(false);
        axios
          .post(getAPIUrl(`/api/share/url/${getData.bookingPK}/`), inputData, { headers })
          .then(function (res) {
            setShareUrl(res.data.share_url);
          })
          .catch((error) => {
            catchError(error);
          });
      };

    const restartVideo = () => {
        if (playerRef.current) {
        playerRef.current?.currentTime(0); // Seek to the beginning
        playerRef.current?.play()?.catch(e => console.log('play:', e.message));
        }
    }

    const skipForward = () => {
        if (playerRef.current) {
        const currTime = playerRef.current?.currentTime();
        playerRef.current?.currentTime(currTime+10);
        }
    }

    const skipBackward = () => {
        if (playerRef.current) {
        const currTime = playerRef.current?.currentTime();
        playerRef.current?.currentTime(currTime-10);
        }
    }

    const copyLinkUrl = () => {
        setLinkCopied(true);
        copy(shareUrl);
        setIsPopupOpen(false)
        setTimeout(() => {
        setLinkCopied(false);
        }, 2000);
    };

    const commentHandler = () => {
      setCommentBox(!commentBox)
      playerRef.current?.pause()
      const current = playerRef.current?.currentTime();
      const formatted = formatTime(current);
      setCommentStartTime(formatted)
      setCommentEndTime(formatted)
      const isEnabled = posthog?.isFeatureEnabled(RECORDING_FLAGS.comment);
      if (isEnabled) {
        posthog.startSessionRecording();
      }
    }

    useEffect(() => {
        const handleFullscreenChange = () => {
          if (document.fullscreenElement) {
            if (window.screen.orientation.lock) {
              videoOrientation.current == 'landscape' && window.screen.orientation.lock('landscape').catch(err => console.error('Error locking orientation:', err));
            }
          } else {
            if (window.screen.orientation.unlock) {
              window.screen.orientation.unlock();
            }
          }
        };
          document.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => {
          document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
      }, []);

    useEffect(() => {
        const requestPlayerFullscreen = () => {
          if (document.fullscreenElement) return;
          const player = playerRef.current;
          const el = player?.el?.();
          const runNative = () => {
            if (!el) return;
            const req =
              el.requestFullscreen ||
              el.webkitRequestFullscreen ||
              el.mozRequestFullScreen ||
              el.msRequestFullscreen;
            if (req) {
              req.call(el).catch(() => {
                videoRef.current?.webkitEnterFullscreen?.();
              });
            } else {
              videoRef.current?.webkitEnterFullscreen?.();
            }
          };
          if (player?.requestFullscreen) {
            player.requestFullscreen().catch(runNative);
          } else {
            runNative();
          }
        };

        const exitPlayerFullscreen = () => {
          const docExit =
            document.exitFullscreen ||
            document.webkitExitFullscreen ||
            document.mozCancelFullScreen ||
            document.msExitFullscreen;
          if (document.fullscreenElement && docExit) {
            try {
              docExit.call(document);
            } catch (_) {}
          }
          try {
            playerRef.current?.exitFullscreen?.();
          } catch (_) {}
          try {
            videoRef.current?.webkitExitFullscreen?.();
          } catch (_) {}
        };

        const handleOrientationChange = () => {
          setCurrentDimensions(window.innerWidth)
          const newOrientation = window.matchMedia("(orientation: portrait)").matches ? "portrait" : "landscape";
          setOrientation(newOrientation);
          const currTime = document.getElementsByClassName('currentTime')
            const totalDuration = document.getElementsByClassName('vjs-time-control')
          if(isMobile() && !isLandScape()){
            currTime[0].style.display = 'flex'
            for (let i = 0; i < totalDuration.length - 1; i++) {
              totalDuration[i].style.display = 'none';
            }
            currTime[0].style.position = 'absolute'
            currTime[0].style.top = '0'
            currTime[0].style.right = '5%'
          }else{
            currTime[0].style.display = 'none'
            for (let i = 0; i < totalDuration.length - 1; i++) {
              totalDuration[i].style.display = 'block';
            }
          }
          const bar = document.getElementsByClassName('vjs-control-bar')[0]
          if(isMobile() && isLandScape()){
            bar.style.bottom = commentBox ? 0.13*window.innerHeight + 'px' : 0.1*window.innerHeight + 'px'
            bar.style.height = '8%'
            // Auto fullscreen when rotating to landscape (once per transition) to avoid Chrome UI covering controls
            if (lastOrientationRef.current !== 'landscape') {
              lastOrientationRef.current = 'landscape';
              setTimeout(() => requestPlayerFullscreen(), 300);
            }
          }else{
            bar.style.bottom = currentDimensions < 600 ? 0.08*window.innerHeight + 'px' : 0.15*window.innerHeight + 'px'
            // Exit fullscreen on portrait (always try — iOS native fullscreen has no document.fullscreenElement)
            if (isMobile() && newOrientation === 'portrait') {
              if (lastOrientationRef.current !== 'portrait') {
                lastOrientationRef.current = 'portrait';
              }
              exitPlayerFullscreen();
            } else if (lastOrientationRef.current !== 'portrait') {
              lastOrientationRef.current = 'portrait';
            }
          }
        };
    
        window.addEventListener('resize', handleOrientationChange);
    
        return () => {
          window.removeEventListener('resize', handleOrientationChange);
        };
    }, [commentBox]);

    useEffect(()=>{
        if(isMobile()){
          setOverlay(true)
        }else{
          setOverlay(false)
        }
      },[])

    useEffect(()=>{
        const ele = document.getElementsByClassName('shareDiv')
        const over = document.getElementsByClassName('overlayMobile')
        if(ele[0] && over[0]){
          if(userActive){
            ele[0].style.visibility = 'visible'
            over[0].style.visibility = 'visible'
          }else{
            ele[0].style.visibility = 'hidden'
            over[0].style.visibility = 'hidden'   
          }
        }
      },[userActive])

    const askVideoDownloadQuality = () => {
      setVideoDetails(data?.url_list)
      setQualityVideo(true)
    }


    const videoDownload = () => {
        setOpenMenu(false)
        const tempAnchor = document.createElement('a')
        const videoUrl = downloadQualityUrl ? downloadQualityUrl : getData.videoUrl;
        tempAnchor.href = videoUrl;
        const videoFileName = videoUrl.split('/').pop().split('?')[0];
        tempAnchor.setAttribute('download', videoFileName);
        window.__LAST_DOWNLOAD_NAME__ = videoFileName;
        tempAnchor.click();
    }

    const currQuality = (e) => {
        setRunQuality(e.target.value)
        setDownloadQuality(e.target.value)
        setDownloadQualityUrl(data.url_list.find(item => item.quality == e.target.value)?.url)
    }


  const qualityOptionSwitch = () => {
    const currentTime = playerRef.current?.currentTime();
    setPlaybackPosition(currentTime);
  };

  const handleMouseMove = () => {
    setUserActive(true)
    const muteButton = document.getElementsByClassName('vjs-volume-panel')[0]
    muteButton && muteButton.classList.add('vjs-hover')
  }

  const handleMouseClick = () => {
    if(playerRef.current?.paused()){
      setUserActive(true)
    }
  }

  const qualityOption = () => {
    setOpenMenu(false)
    setOpenQuality(true)
  }

  const playbackOption = () => {
    setOpenMenu(false)
    setOpenRate(true)
  }


  useEffect(() => {
    const handleKeyDown = (event) => {
      if(commentBox){
        return
      }
      switch (event.key) {
        case 'ArrowUp':
          const currentVolume = playerRef.current?.volume();
          const increasedVolume = Math.max(currentVolume + 0.1, 0); 
          playerRef.current?.volume(increasedVolume);
          break;
        case 'ArrowDown':
          const currentVolume2 = playerRef.current?.volume();
          const decreasedVolume = Math.max(currentVolume2 - 0.1, 0); 
          playerRef.current?.volume(decreasedVolume);
          break;
        case 'ArrowLeft':
          skipBackward()
          break;
        case 'ArrowRight':
          skipForward()
          break;
        case ' ':
          if(playerRef.current?.paused()){
            playerRef.current?.play()?.catch(e => console.log('play:', e.message))
          }else{
            playerRef.current?.pause()
            setUserActive(true)
          }
          break;
        default:
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [commentBox]);

  const getCountdownWindow = () => {
    if (videoDuration < 60) return 5;
    if (videoDuration <= 600) return 30;
    return 60;
  };

  const shouldShowNextButton = () => {
    if (!videoDuration || videoDuration <= 0) return false;
    const remaining = videoDuration - completedTime;
    return remaining <= getCountdownWindow();
  };

  const getNextBtnBottom = () => {
    const isPortrait = isMobile() && !isLandScape()
    const barH = isMobile() && currentDimensions < 600 ? 0.1 * window.innerHeight : 48
    if (isPortrait) {
      const base = commentBox ? (currentDimensions < 600 ? 0.1 : 0.15) : 0.2
      return base * window.innerHeight + barH + 20
    }
    return (commentBox ? 0.13 : 0.1) * window.innerHeight + barH + 20
  }

  const debounce = (func, delay) => {
    let timeoutId;
    return function(...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };


  const changePlaybackRate = (rate) => {
    if (playerRef.current !== null) {
      playerRef.current?.playbackRate(rate);
      setOpenRate(false)
      setOpenMenu(true)
      if(rate==1){
        setPlaybackRate('Normal')
      }else{
        setPlaybackRate(rate+'x')
      }
    }
  };

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    return () => {
        body.style.overflow = 'auto';
    };
  }, []);

  return (
    <>
        <div style={{width: commentBox && !isMobile() ? "75vw" : "100vw", height: commentBox && isMobile() ? "50vh" : "100vh"}} data-vjs-player>
            <video ref={videoRef} className="video-js vjs-default-skin" onContextMenu={(e) => e.preventDefault()}/>
            <div className='qualityDiv' style={{top: commentBox && !isLandScape() ? '45%' : '35%'}} ref={playBackRef}>
              {openQuality && 
              <div className='qualityMenu'>
                {data.url_list.map((e,index)=>{
                  return(
                    <>
                      <label key={index} onClick={currQuality} className='qualitySelect'><input type="radio" name='options' value={`${e.quality}`} checked={runQuality==e.quality && 'checked'} onChange={() => qualityOptionSwitch()}/><p className='qualityBlock'>{e.name}</p>{e.quality === 1080 && <span className='hdDiv'>HD</span>}</label>
                    </>
                  )
                })}
                <div onClick={()=>{setOpenQuality(false);setOpenMenu(true)}} className='mainMenu'><FontAwesomeIcon icon={faCaretLeft} style={{color: "#000000", paddingRight:"8px"}} /> Quality</div>
              </div>}
              {openRate &&
                <div className='rateMenu'>
                  <div onClick={()=>{setOpenRate(false);setOpenMenu(true)}} className='mainMenu'><FontAwesomeIcon icon={faCaretLeft} style={{color: "#000000", paddingRight:"8px"}} /> Speed</div>
                  <label onClick={() => changePlaybackRate(0.5)} className='rateSelect'><input type='radio' name='rates' value='0.5' checked={playbackRate==0.5+'x' && 'checked'} onChange={() => qualityOptionSwitch()}/><p style={{paddingLeft:"10px"}}>0.5x</p></label>
                  <label onClick={() => changePlaybackRate(0.75)} className='rateSelect'><input type='radio' name='rates' value='0.25' checked={playbackRate==0.75+'x' && 'checked'} onChange={() => qualityOptionSwitch()}/><p style={{paddingLeft:"10px"}}>0.75x</p></label>
                  <label onClick={() => changePlaybackRate(1)} className='rateSelect'><input type='radio' name='rates' value='1' checked={playbackRate=='Normal' && 'checked'} onChange={() => qualityOptionSwitch()}/><p style={{paddingLeft:"10px"}}>Normal</p></label>
                  <label onClick={() => changePlaybackRate(1.25)} className='rateSelect'><input type='radio' name='rates' value='1.25' checked={playbackRate==1.25+'x' && 'checked'} onChange={() => qualityOptionSwitch()}/><p style={{paddingLeft:"10px"}}>1.25x</p></label>
                  <label onClick={() => changePlaybackRate(1.5)} className='rateSelect'><input type='radio' name='rates' value='1.5' checked={playbackRate==1.5+'x' && 'checked'} onChange={() => qualityOptionSwitch()}/><p style={{paddingLeft:"10px"}}>1.5x</p></label>
                  <label onClick={() => changePlaybackRate(2)} className='rateSelect'><input type='radio' name='rates' value='2' checked={playbackRate==2+'x' && 'checked'} onChange={() => qualityOptionSwitch()}/><p style={{paddingLeft:"10px"}}>2x</p></label>
                </div>}
              {openMenu && <div className='extraMenu'>
                <button className='oneMenu' onClick={qualityOption}>
                  <span>Quality</span>
                  <span>{qualityShortName}<FontAwesomeIcon icon={faCaretRight} style={{color: "#000000", paddingLeft:"5px"}} /></span>
                </button>
                <button className='oneMenu' onClick={playbackOption}>
                  <span>Speed</span>
                  <span>{playbackRate}<FontAwesomeIcon icon={faCaretRight} style={{color: "#000000", paddingLeft:"5px"}} /></span>
                </button>
              </div>}
              <FontAwesomeIcon icon={faGear} onClick={showMenu} size="xl" style={{color: "#ffffff",cursor: "pointer"}} />
            </div>
            <div className='currentTime' ref={currRef}></div>
            {data?.can_request_changes && !shared_key && <div onClick={()=>commentHandler()} ref={commentRef} className='commentDiv' style={{display:"flex", alignItems:"center", padding:"0 10px", cursor:"pointer", height: currentDimensions < 600 && 'fit-content', position: 'relative', top: currentDimensions < 600 && (commentBox && !isLandScape() ? '45%' : '35%')}}>
              <img className='invert-image' style={{width:"18px", height:"18px", cursor:"pointer" }} src={commentIcon}/>
              {showCommentTooltip && (
                <div style={{
                  position:'absolute',
                  ...(currentDimensions < 600 ? { top:'150%' } : { bottom:'150%' }),
                  right:0,
                  background:'white',
                  color:'black',
                  padding:'6px 10px',
                  fontSize:'larger',
                  borderRadius:'6px',
                  whiteSpace:'nowrap',
                  display:'flex',
                  alignItems:'center',
                  gap:'8px',
                  zIndex:1000
                }} className='commentTooltip'>
                  <span>Request Changes</span>
                  <button onClick={(e)=>{ e.stopPropagation(); setShowCommentTooltip(false); if(commentTooltipTimeoutRef.current) clearTimeout(commentTooltipTimeoutRef.current); }} style={{ background:'transparent', border:'none', color:'black', cursor:'pointer', fontSize:'larger', lineHeight:1 }}>×</button>
                  {currentDimensions < 600 ? (
                    <div style={{ position:'absolute', top:'-6px', right:'10px', width:0, height:0, borderLeft:'6px solid transparent', borderRight:'6px solid transparent', borderBottom:'6px solid white' }} />
                  ) : (
                    <div style={{ position:'absolute', bottom:'-6px', right:'10px', width:0, height:0, borderLeft:'6px solid transparent', borderRight:'6px solid transparent', borderTop:'6px solid white' }} />
                  )}
                </div>
              )}
            </div>}
            <div onClick={restartVideo} style={{display: !isMobile() ? "flex" : "none", alignItems:"center", padding:"0 10px", cursor:"pointer"}} ref={retryRef}><FontAwesomeIcon size='xl' style={{color: "#ffffff"}} icon={faRotateLeft} rotation={90} /></div>
            <div onClick={skipBackward} style={{display: !isMobile() ? "flex" : "none", alignItems:"center", padding:"0 10px", cursor:"pointer"}} ref={backwardRef}><FontAwesomeIcon icon={faBackward} size="xl" style={{color: "#ffffff",}} /></div>
            <div onClick={skipForward} style={{display: !isMobile() ? "flex" : "none", alignItems:"center", padding:"0 10px", cursor:"pointer"}} ref={forwardRef}><FontAwesomeIcon icon={faForward} size="xl" style={{color: "#ffffff",}} /></div>
            <div className='navbarVideo' style={{display: isMobile() && orientation=='landscape' ? 'none' : "flex", alignItems: "center", position:"absolute", width:"inherit", justifyContent: (isMobile() && orientation=='landscape') ? 'end' : "space-between", fontSize:"large", padding: orientation=='landscape' ? '1%' : "1% 5%", zIndex: "100"}}>
              <div style={{display: isMobile() && orientation=='landscape' && 'none', visibility:"hidden"}}><img
                      className="logoEg"
                      src={get_logo()}
                    /></div>
              <div
                style={{
                  visibility: userActive ? 'visible' : 'hidden',
                  display: isMobile() && orientation == 'landscape' && 'none',
                  fontSize: currentDimensions < 600 && 'smaller'
                }}
              >
                {data.title
                  ? data.title.length > 18
                    ? data.title.slice(0, 15) + '...'
                    : data.title
                  : ''}
              </div>
              {data.is_downloadable && <div ref={downloadRef} className='videoDownloadDiv' style={{ visibility : userActive ? 'visible' : "hidden", top: commentBox && !isLandScape() ? '45%' : (isLandScape() ? '30%' : '35%')}} onClick={askVideoDownloadQuality} ><FontAwesomeIcon icon={faDownload} size='xl' style={{color: "#ffffff",}} /></div>}
              {data.is_shareable ? <div style={{ visibility: (userActive) ? 'visible' : 'hidden' }} className='shareDiv' onClick={!isAdmin() && ShareCall}>
                <FontAwesomeIcon  icon={faShareNodes} style={{color: "#ffffff"}} /></div> : <div style={{width:"40px"}}>
              </div>}
            </div>
            <div style={{visibility : userActive ? 'visible' : "hidden", display: !isMobile() && 'none'}} className='overlayMobile'>
              <div onClick={skipBackward} style={{display: isMobile() ? "flex" : "none", alignItems:"center", margin:"0 5rem", cursor:"pointer", zIndex:"100"}}><FontAwesomeIcon icon={faBackward} size="2xl" style={{color: "#ffffff",}} /></div>
              <div onClick={manualPlay} style={{display: "flex", alignItems:"center", cursor:"pointer", zIndex:"100"}}><FontAwesomeIcon icon={isPaused ? faPlay : faPause} size="2xl" style={{color: "#ffffff",}} /></div>
              <div onClick={skipForward} style={{display: isMobile() ? "flex" : "none", alignItems:"center", margin:"0 5rem", cursor:"pointer", zIndex: "101"}}><FontAwesomeIcon icon={faForward} size="2xl" style={{color: "#ffffff",}} /></div>
            </div>
            {nextVideo && shouldShowNextButton() && (
              <div
                onClick={getData.onNextVideo}
                style={{
                  position: 'absolute',
                  right: '16px',
                  bottom: getNextBtnBottom() + 'px',
                  visibility: userActive ? 'visible' : 'hidden',
                  cursor: 'pointer',
                  zIndex: 110,
                  userSelect: 'none',
                  overflow: 'hidden',
                  borderRadius: '4px',
                  border: '2px solid #fff',
                  background: '#fff',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.6)',
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: currentDimensions < 600 ? '6px 14px' : '9px 18px',
                  fontSize: currentDimensions < 600 ? '13px' : '15px',
                  fontWeight: '700',
                  color: '#111',
                  whiteSpace: 'nowrap',
                }}>
                  <span>Next</span>
                  <FontAwesomeIcon icon={faForwardStep} style={{ fontSize: currentDimensions < 600 ? '12px' : '14px' }} />
                </div>
              </div>
            )}
        </div>
        {data?.can_request_changes && <CommentBox
          isOpen={commentBox}
          setCommentBox={setCommentBox}
          commentBox={commentBox}
          commentText={commentText}
          setCommentText={setCommentText}
          commentStartTime={commentStartTime}
          setCommentStartTime={setCommentStartTime}
          commentEndTime={commentEndTime}
          setCommentEndTime={setCommentEndTime}
          completedTime={completedTime}
          playerRef={playerRef}
          onSetStartTime={() => {
            const t = playerRef.current?.currentTime();
            setCommentStartTime(formatTime(t));
          }}
          onSetEndTime={() => {
            const t = playerRef.current?.currentTime();
            setCommentEndTime(formatTime(t));
          }}
        />}
        <Popup
          isOpen={isPopupOpen}
          onClose={() => {
            setIsPaused(false)
            playerRef.current?.play()?.catch(e => console.log('play:', e.message))
            setIsPopupOpen(false);
          }}
        >
          <div style={{ textAlign: "center", padding: "0 30px" }}>
            <div style={{ fontSize: "large", paddingTop: "0.2rem" }}>
              Share this quotation
            </div>     
            <div onClick={copyLinkUrl} className="cpyAlbum">
          <FontAwesomeIcon
              icon={faCopy}
              style={{ color: "#ffffff" }}
          />
            Copy Link
            </div>
            <div>
            <Link target='_blank' onClick={() => openExternalApp(`${getWhatsappShareUrl(shareUrl)}`)}>
              <button className="shareWp">
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  style={{ color: "#ffffff" }}
                />
                Share
              </button>
            </Link>  
            </div>  
          </div>     
        </Popup>

        {qualityVideo && <Popup
            isOpen={true}
            onClose={() => {
            setQualityVideo(false);
        }}>
            <div style={{margin:"0 20px", justifyItems:"center", display:"grid"}}>
                <div style={{textAlign:"center", fontWeight:"600", fontSize:"23px", padding:"5px"}}>Quality</div>
                {videoDetails?.map((e) => {
                    return <div key={e.quality} className="qualityRadio">
                        <label style={{display:"flex", alignItems:"center", justifyContent:"space-between", minWidth:"170px"}}>
                            <p>{e.name}</p>
                            <input
                            type="radio"
                            name="video"
                            value={e.quality}
                            checked={e.quality==downloadQuality}
                            onChange={() => {setDownloadQualityUrl(e.url); setDownloadQuality(e.quality)}}
                            style={{accentColor:get_platform_action_color()}}
                            />
                        </label>
                    </div>;
                })}
                <div style={{padding:"5px 10px", borderRadius:"5px", color:"white", background: get_platform_action_color(), width:"fit-content", margin:"5px", cursor:"pointer"}} onClick={() => {setQualityVideo(false); videoDownload(); }}>Download</div>
            </div>
        </Popup>} 

        {linkCopied && (
                <div
                  style={{
                    position: "fixed",
                    bottom: "11vh",
                    borderRadius: "0.5rem",
                    right: "1rem",
                    padding: "0.3rem 1.5rem",
                    zIndex: "1000",
                    backgroundColor: "rgb(91 91 91 / 70)",
                  }}
                >
                  <div
                    id="liveToast"
                    className="toast hide"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    <div className="toast-body" style={{ color: "white" }}>
                      Link Copied
                    </div>
                  </div>
                </div>
        )}
    </>
  )
}

export default VideoPlayer